import React from 'react'

import { SiteDataContext } from '../../../components/page-wrapper'
import { LoadMore, Testimonials } from '../../../storybook'
import { getMicroCopy } from '../../../utils/microcopy'
import { useMicroCopyData } from '@/src/context/MicroCopyContext'
import { Image as DatoImage } from 'react-datocms'

function TestimonialsListing({ customers = [], limit = 6, slugPrefix }) {
  const microCopyData = useMicroCopyData()
  const { lang } = React.useContext(SiteDataContext)
  const [offsetToShow, setOffsetToShow] = React.useState(limit)

  const customersToShow = customers.slice()

  const stories = customersToShow.slice(0, offsetToShow).map((item) => {
    return {
      id: item?.id || '',
      name: item?.name,
      type: item.type ? getMicroCopy({ key: `${item.type.key}`, data: microCopyData[lang] }) : '',
      logo: item?.logo && { image: item?.logo?.url, title: item?.logo?.title },
      image: item?.image ? (
        <DatoImage data={item?.image?.responsiveImage || item?.image} objectFit="cover" />
      ) : null,
      title: item?.quote,
      actionLabel: getMicroCopy({ key: 'readTestimonial', data: microCopyData[lang] }),
      url: `/${slugPrefix}customers/${item.slug}`.replace(/\/{2,}/gim, '/')
    }
  })

  const footerSlot = offsetToShow < customersToShow.length && (
    <div className="l-section__footer">
      <LoadMore
        current={offsetToShow}
        total={customersToShow.length}
        loadLabel={getMicroCopy({ key: 'paginationLoadMore', data: microCopyData[lang] })}
        separationLabel={getMicroCopy({ key: 'paginationOf', data: microCopyData[lang] })}
        handleLoadMore={() => setOffsetToShow(offsetToShow + limit)}
      />
    </div>
  )

  return <Testimonials stories={stories} footerSlot={footerSlot} />
}

export default TestimonialsListing
